import reducer from './reducer';
import watchers from './sagas';

export { reducer };
export default watchers;
